'use client';

import { useEffect } from 'react';
import { notesStatusEvents } from '@/sharedTypes/coreTypes';
import { sendStat } from './statsApi';
import { CreateStatRequest } from '@/sharedTypes/Api';

/**
 * StatsListener - Listens for STATS_SEND events from darpiano-front
 * and sends the stats to the backend via API.
 *
 * This component bridges darpiano-front (which tracks practice stats)
 * with the backend API (which persists them).
 *
 * Stats are sent on inactivity timeout (15s) and sample change.
 * Session-based merging on backend ensures no data loss.
 */
export default function StatsListener() {
  useEffect(() => {
    const handleStatsSend = async (event: Event) => {
      const customEvent = event as CustomEvent<CreateStatRequest>;
      const stat = customEvent.detail;

      console.log('[StatsListener] Received STATS_SEND event');
      console.log('[StatsListener] Stat data:', stat);

      if (!stat) {
        console.warn('[StatsListener] No stat data in event');
        return;
      }

      await sendStat(stat);
    };

    console.log('[StatsListener] Registering listener for STATS_SEND events');
    window.addEventListener(notesStatusEvents.STATS_SEND, handleStatsSend);

    return () => {
      console.log('[StatsListener] Removing STATS_SEND listener');
      window.removeEventListener(notesStatusEvents.STATS_SEND, handleStatsSend);
    };
  }, []);

  return null;
}
